import { inputTestIds } from 'aem-libs-tests/src/utility/inputTestIds'

const initialDepositInput = 'initialDepositInput'
const monthlyDepositInput = 'monthlyDepositInput'
const ageInput = 'ageInput'

export const testIds = {
  initialDepositInputBase: initialDepositInput,
  monthlyDepositInputBase: monthlyDepositInput,
  ageInputBase: ageInput,
  initialDepositInput: inputTestIds(initialDepositInput),
  monthlyDepositInput: inputTestIds(monthlyDepositInput),
  ageInput: inputTestIds(ageInput),
  calculateButton: 'calculateButton',
  savingsTotalResult: 'savingsTotalResult',
  savingsReturnResult: 'savingsReturnResult',
  savingsOneYearSavingsResult: 'savingsOneYearSavingsResult',
  savingsOneYearReturnResult: 'savingsOneYearReturnResult',
  cta: 'resultCta'
}
